import { useTranslation } from 'react-i18next';
import { FormControl } from '@mui/material';

import { CustomFormLabel, RHFContractorSelectField } from '@/components/form-controls';
import { CONTRACTOR_TYPE_MARKET_ORG } from '@/shared/constants/contractor-types.constants';

const fetchParams = {
  contractor_type_aliases: [CONTRACTOR_TYPE_MARKET_ORG],
};

export const MarketingOrganisationField = () => {
  const { t } = useTranslation('nomenclature-page');

  return (
    <FormControl fullWidth>
      <CustomFormLabel>{t('modals.form.ui.expert-data.marketing-organization')}</CustomFormLabel>
      <RHFContractorSelectField
        name="marketingOrg"
        id="marketingOrg"
        TextFieldProps={{ variant: 'filled' }}
        fetchParams={fetchParams}
      />
    </FormControl>
  );
};
